/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import ToggleMenu from "./modules/ToggleMenu";
import ProductsSlider from "./modules/ProductsSlider";
import MainSlider from "./modules/MainSlider";
import CategoriesSlider from "./modules/CategoriesSlider";
import Accordion from "./modules/Accordion";
import QuantityButtons from "./modules/QuantityButtons";
import FaqAccordion from "./modules/FaqAccordion";
import QuickLook from "./modules/QuickLook";
import AddToCart from "./modules/AddToCart";
import MyAccountReturns from "./modules/MyAccountReturns";
import MyAccountComplaint from "./modules/MyAccountComplaint";
import MyAccountOrders from "./modules/MyAccountOrders";
import GetProductsByAttr from "./modules/GetProductsByAttr";
import Newsletter from "./modules/Newsletter";
import SidebarSlider from "./modules/SidebarSlider";
import SelectPlaceholder from "./modules/SelectPlaceholder";
import BackBtn from "./modules/BackBtn";
import Search from "./modules/Search";
import Checkout from "./modules/Checkout";
import SingleProduct from "./modules/SingleProduct";
import CustomLogos from "./modules/CustomLogos";
import MyAccountRegister from "./modules/MyAccountRegister";
import AutocompleteCities from "./modules/AutocompleteCities";
import LangModal from "./modules/LangModal";
import Notices from "./modules/Notices";
import DisableAddressInputs from "./modules/DisableAddressInputs";

// Multisite -> changes cart JS
import WooCommerceCart from "./modules/WooCommerceCart";

document.addEventListener("DOMContentLoaded", function (event) {
    const toggleMenu = new ToggleMenu();
    const productSlider = new ProductsSlider();
    const categoriesSlider = new CategoriesSlider();
    const mainSlider = new MainSlider();
    const sidebarAccordion = new Accordion("accordion-header");
    const checkoutAccordion = new Accordion("jsAccordionHeader");
    const myOrderAccordion = new Accordion("jsCustomerDetailsTitle");
    const faqAccordion = new FaqAccordion("jsFaqItem");
    const getProductsByAttr = new GetProductsByAttr();
    const quickLook = new QuickLook("jsQuickLook");
    // const quantityBonus = new QuantityButtons();
    const newsletter = new Newsletter();
    const sidebarSlider = new SidebarSlider();
    const addToCart = new AddToCart();
    const selectPlaceholder = new SelectPlaceholder("register-form__select");
    const initSearch = new Search();
    const initCheckout = new Checkout();
    const accountReturns = new MyAccountReturns();
    const accountComplaint = new MyAccountComplaint();
    const accountOrders = new MyAccountOrders();
    const backBtn = new BackBtn();
    const singleProduct = new SingleProduct();
    const customLogos = new CustomLogos();
    const myAccountRegister = new MyAccountRegister();
    const initDisableAddressInputs = new DisableAddressInputs();
    const initLangModal = new LangModal();
    //const initAutocompleteCities = new AutocompleteCities();
    const initWooCommerceCart = new WooCommerceCart();

    if (window.global.check_or_cart) {
        const notices = new Notices();
    }

    addToCart.init();
    getProductsByAttr.init();
});
